import { connect } from 'react-redux';

// components

import { getOrderTariffTexts } from "../../../store/selectors/orderTariffCommon";
import { OrderStatusPopup } from "../../common/OrderStatusPopup";
var mapStateToProps = function mapStateToProps(state) {
  return {
    texts: getOrderTariffTexts(state).alreadyInUseTexts
  };
};
export var AddressAlreadyInUse = connect(mapStateToProps)(OrderStatusPopup);